/* eslint-disable*/
"use strict";
var widgetId1;

// ReCaptcha v2 module builder
function buildRecaptchaV2() {
    $("#googleRecaptchaV2").css("display", "block");
    widgetId1 = grecaptcha.ready(function () {
        try {
            grecaptcha.render("googleRecaptchaV2", {
                sitekey: $("#google-recaptcha-main").data("google-recaptchav2-key")
            });
        } catch (err) {
            console.log(err.message);
        }
    });
}

// Individual method to handle reCaptcha v2 response
function getRecaptchaV2Response() {
    return new Promise(function (resolve, reject) {
        if (!$("#google-recaptcha-main").data("google-recaptchav2-enabled")) {
            resolve(true);
        } else {
            if ($("#googleRecaptchaV2:visible").length < 1) {
                buildRecaptchaV2();
            }
            $.ajax({
                url: $("#google-recaptcha-main").data("google-recaptchav2-url"),
                type: "POST",
                dataType: "json",
                data: {
                    token: grecaptcha.getResponse(widgetId1)
                },
                success: function (responseData) {
                    if (responseData.statusCode === 200) {
                        if (!responseData.data.success) {
                            grecaptcha.reset(widgetId1);
                            reject(false);
                        } else {
                            grecaptcha.reset(widgetId1);
                            $("#googleRecaptchaV2").css("display", "none");
                            resolve(true);
                        }
                    } else {
                        grecaptcha.reset(widgetId1);
                        $("#googleRecaptchaV2").css("display", "none");
                        reject(false);
                    }
                }
            });
        }
    });
}

// Generate a fresh reCaptcha v3 token to be posted together with the form so the
// action endpoint can verify it server-side. Resolves "" for forms that do not opt
// in (via data-recaptcha-protect) or when v3 is disabled/unavailable.
function getRecaptchaToken($form) {
    return new Promise(function (resolve, reject) {
        var $main = $("#google-recaptcha-main");

        if (!$form || !$form.data("recaptcha-protect") || !$main.data("google-recaptchav3-enabled")) {
            resolve("");
            return;
        }

        var siteKey = $main.data("google-recaptchav3-key");

        if (typeof grecaptcha === "undefined" || !siteKey) {
            resolve("");
            return;
        }

        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, {
                action: "submit"
            }).then(function (token) {
                resolve(token);
            }, function () {
                reject(false);
            });
        });
    });
}

// Handle reCaptcha behavior, calling both v2 and v3 or handling only one version.
function getRecaptchaResponse() {
    return new Promise(function (resolve, reject) {
        if (!$("#google-recaptcha-main").data("google-recaptchav3-enabled")) {
            if ($("#google-recaptcha-main").data("google-recaptchav2-enabled")) {
                getRecaptchaV2Response().then(
                    function (value) {
                        resolve(true);
                    },
                    function (error) {
                        reject(false);
                    }
                );
            } else {
                resolve(true);
            }
        } else if ($("#googleRecaptchaV2:visible").length < 1) {
            grecaptcha.ready(function () {
                grecaptcha.execute($("#google-recaptcha-main").data("google-recaptchav3-key"), {
                    action: "submit"
                }).then(function (token) {
                    $.ajax({
                        url: $("#google-recaptcha-main").data("google-recaptchav3-url"),
                        method: "POST",
                        dataType: "json",
                        data: {
                            token: token
                        },
                        success: function (responseData) {
                            if (responseData.statusCode === 200) {
                                if (responseData.data.score < $("#google-recaptcha-main").data("google-recaptchav3-score")) {
                                    if ($("#google-recaptcha-main").data("google-recaptchav2-enabled")) {
                                        buildRecaptchaV2();
                                    } else {
                                        reject(false);
                                    }
                                } else {
                                    resolve(true);
                                }
                            } else {
                                reject(false);
                            }
                        }
                    });
                });
            });
        } else {
            getRecaptchaV2Response().then(
                function (value) {
                    resolve(true);
                },
                function (error) {
                    reject(false);
                }
            );
        }
    });
}

module.exports = {
    getRecaptchaResponse: getRecaptchaResponse,
    getRecaptchaV2Response: getRecaptchaV2Response,
    getRecaptchaToken: getRecaptchaToken,
    buildRecaptchaV2: buildRecaptchaV2
};
